const SET_DOCUMENT_DATA = 'SET_DOCUMENT_DATA'
const RESET_DOCUMENT_DATA = 'RESET_DOCUMENT_DATA'
const SET_MOVE_SELECTED_DOCUMENTS_DATA = 'SET_MOVE_SELECTED_DOCUMENTS_DATA'

export default {
  SET_DOCUMENT_DATA,
  RESET_DOCUMENT_DATA,
  SET_MOVE_SELECTED_DOCUMENTS_DATA
}
